export default __webpack_public_path__ + "static/media/block8-banner2.5034e39e.png";